import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-mdl-reschedule-campaign',
  imports: [FormsModule, CommonModule],
  templateUrl: './mdl-reschedule-campaign.html',
  styleUrl: './mdl-reschedule-campaign.css'
})
export class MdlRescheduleCampaign {

  public newDate: string = '';
  public newHour: string = '';

  constructor(
    public mdl: MatDialogRef<MdlRescheduleCampaign>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){}

  closeMdl(){
    this.mdl.close();
  }

  rescheduleCampaign(){
    
  }
}
